import { render, staticRenderFns } from "./ShowcaseFeedback.vue?vue&type=template&id=4072e8d9&scoped=true"
import script from "./ShowcaseFeedback.vue?vue&type=script&lang=js"
export * from "./ShowcaseFeedback.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseFeedback.vue?vue&type=style&index=0&id=4072e8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072e8d9",
  null
  
)

export default component.exports